import { loadStripe } from '@stripe/stripe-js';

import Component from './Component.vue'
import Selection from './Selection.vue'

export default {
  guid: '29bdebaccd9e452fac2be8963d3daba7',
  component: Component,
  selection: Selection,
  async externalPaymentCallback (guid) {
    const { $store } = useNuxtApp()
    const route = useRoute()

    const integrations = $store.getters['location/integrations']
    const integration = integrations[guid]
    const pk = integration.data.publishableKey

    const stripe = await loadStripe(pk)
    const query = route.query

    if (query.payment_intent) {
      const secret = query.payment_intent_client_secret

      if (secret) {
        const { paymentIntent } = await stripe.retrievePaymentIntent(secret)

        if (paymentIntent.status === 'succeeded' || paymentIntent.status === 'requires_capture') {
          return {
            success: true,
            params: { paymentIntent: query.payment_intent },
            errors: []
          }
        }

        // app.$sentry?.captureException(new Error(`Stripe error: ${paymentIntent.status}`))
      }
    }

    if (query.setup_intent) {
      const secret = query.setup_intent_client_secret

      if (secret) {
        const { setupIntent } = await stripe.retrieveSetupIntent(secret)

        if (setupIntent.status === 'succeeded' || setupIntent.status === 'requires_capture') {
          return {
            success: true,
            params: { setupIntent: query.setup_intent },
            errors: []
          }
        }

        // app.$sentry?.captureException(new Error(`Stripe error: ${paymentIntent.status}`))
      }
    }

    return {
      success: false,
      params: null,
      errors: ['Payment failed: Sorry, there was an error processing your payment. Please try again...']
    }
  }
}
